'use client';

import React from 'react';

interface RTFContentProps {
  content: string;
}

const RTFContent: React.FC<RTFContentProps> = ({content}) => {
  if (!content) {
    return null;
  }

  return (
    <div
      className="rtf-content prose max-w-none borderless-editor"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default RTFContent;